import Modal from 'LuxKit/Modal/Modal'
import TourV2FinePrint from 'components/OfferPage/TourV2/FinePrint/TourV2FinePrint'
import type { ComponentProps } from 'react'
import React, { memo } from 'react'
import { useIntl } from 'react-intl'

type InheritedModalProps = Pick<ComponentProps<typeof Modal>, 'subtitle'>

interface Props extends InheritedModalProps {
  finePrint: App.Tours.TourV2OfferFinePrint
}

function TourV2FinePrintModal(props: Props) {
  const intl = useIntl()
  const { finePrint, subtitle } = props

  return <Modal
    title={intl.formatMessage({
      id: '5E3AWDmsHK',
      defaultMessage: 'Trip Fine Print',
      description: 'Modal title for tour fine print',
    })}
    subtitle={subtitle}
  >
    <TourV2FinePrint finePrint={finePrint} />
  </Modal>
}

export default memo(TourV2FinePrintModal)
